/**
 * created by yxy
 * 采访任务 详情页
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {message, Modal, Tabs, Button} from 'antd';
import StoryList from '../components/btn/StoryList';
import TaskPicture from "../components/btn/TaskPicture";
import TaskMessage from "./viewBtn/TaskMessage";
import {ArrayDuplication, permissionCheck, uuid} from '../../../utils/index'
import {PIC_TYPE, VIDEO_TYPE} from "../../../constants";
import AddInterviewTasks from "./addInterview";

const {TabPane} = Tabs;
export default class Details extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            taskId: "",
            current: "0",
            tableList: [],
            buttons: [],
            data: {},
            showModalKey: uuid(),
            deleteList:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {


    }


    sysConfigLoadOver() {

    }

    show(id, data) {
        this.state.current = '0';
        this.getData(id, (res) => {
            if (data && data.length) {
                this.state.tableList = data;
            }
            this.state.data = res;
            this.state.taskId = id;
            this.state.visible =true;
            this.state.showModalKey= uuid();
            this.setState({},()=>{
                this.isShowBtn(data);
            });

        });
    }

    isShowBtn(data) {
        let bts = [];
        let newButton = [];
        bts = data[parseInt(this.state.current)].button;
        bts && bts.length && bts.forEach((item, index) => {
            let isAdd = false;
            if (item.condition) {
                if (item.condition.indexOf(this.state.data.status) !== -1) {
                    isAdd = true;
                }
            } else if (typeof item.conditionFun == "function") {
                isAdd = item.conditionFun(this, window.currentUser,this.state.data.status);
            }
            if (isAdd) {
                newButton.push(item)
            }
        });
        this.setState({buttons: newButton}, () => {

        })
    }

    //根据id 获取数据
    getData(id, call) {
        let url = '/cm-sites-business/bd/busTask/getById/';
        this.request({
            url: "" + url + id,
            method: "post",
            body: {
                "showRef": [
                    "taskReporterIds",
                    "clueId",
                    "topicSelectionId"
                ]
            },
            contentType: 'json',
            callBack: (data) => {
             
                call && call(data)
            }
        });
    }

    render() {
        let {buttons} = this.state;
        let {tableList} = this.state;
        let that = this;
        let details = {
            'current_0': <TaskMessage id={this.state.taskId} ref={ref => this.taskMessage = ref} callBack={() => {
                that.props.callBack && that.props.callBack()
            }}/>,
            'current_1': <StoryList id={this.state.taskId} callBack={() => {
                that.props.callBack && that.props.callBack()
            }}/>,
            'current_2': <TaskPicture ref={ref => this.taskPicture1 = ref} id={this.state.taskId}
                                      showCheck={false}

                                       key={'pic'}
                                      current={"2"}/>,
            'current_3': <TaskPicture ref={ref => this.taskPicture2 = ref} id={this.state.taskId}
                                      showCheck={false}
                                       key={'video'}
                                      deleteCallBack={(data)=>{
                                          this.setState({deleteList:data})

                                      }}
                                      current={"3"}/>,
        };
        return (
            <Modal
                title="查看任务详情"
                visible={this.state.visible}
                maskClosable={false}
                width={800}
                className={'interModel'}
                footer={<div key={uuid()} className={"taskDetailBtn"}>{buttons && buttons.length>0 ? buttons.map((item, index) => {
                    if (item.component) {
                        let RenderExtendComponent = null;
                        try {
                            RenderExtendComponent = require(`../columnRender/${item.component}`).default;
                        } catch (e) {
                            console.log(e.toString())
                        }

                        return RenderExtendComponent ? (
                            <div className={"taskDetailBtnItem"} key={index}>
                                <RenderExtendComponent
                                    {...item}
                                    taskId={this.state.taskId}
                                    onClick={() => {
                                        item.onOk(this)
                                    }}
                                    menuListOnclick={(menuItem) => {
                                        menuItem.onOk(this)
                                    }}
                                    closeNoAuth={()=>{
                                        this.closeNoAuth()
                                    }}
                                    uploadOnOk={(obj)=>{
                                        item.onOk(this,obj)
                                    }}
                                />
                            </div>
                        ) : ""
                    } else {
                        return <div className={"taskDetailBtnItem"}  key={index}><Button type={item.type} onClick={() => {
                            item.onOk(this)
                        }}>{item.name}</Button></div>
                    }
                }):""}
                </div>}
                onCancel={() => {
                    this.setState({visible: false})
                }}
                key={this.state.showModalKey}
            >
                <div style={{height: '480px'}}>
                    {/*{tableList.map((item, Index) => {*/}
                    {/*})}*/}
                    <Tabs activeKey={this.state.current} onChange={(value) => {
                        this.tabsChange(value);
                    }}>
                        {
                            tableList && tableList.length && tableList.map((item, index) => {
                                let component = details['current_' + item.id] || "";
                                return (<TabPane tab={item.name} key={item.id}>
                                    {
                                        component
                                    }
                                </TabPane>)
                            })
                        }
                    </Tabs>
                    {/*{*/}
                    {/*    details['current_' + this.state.current]*/}
                    {/*}*/}
                    <AddInterviewTasks key={this.state.addInterviewTasksKey} ref={(addInterview) => {
                        this.addInterview = addInterview
                    }} callBack={()=>{
                       this.props.callBack&&this.props.callBack()
                    }}></AddInterviewTasks>
                </div>
                <style>{`
                .interModel .ant-modal-body{padding:8px;} 
                .taskDetailBtn {display:flex;justify-content: center;}
                .taskDetailBtn .taskDetailBtnItem {width:auto;margin-right:10px}
                .taskDetailBtn .taskDetailBtnItem:last-child {margin-right:unset}
                `}</style>
            </Modal>
        )
    }

    tabsChange = (value) => {
		//增加同时拥有领取权限和创建权限条件判断
        const change = ()=>{
            this.state.current = value;
                this.state.buttons = [];
                this.setState({}, () => {
                    this.isShowBtn(this.state.tableList)
                })
        }
        if(permissionCheck("interviewTask_creator")){
            // 创建者
            change();
        } else if(permissionCheck("interview_accept") ){
            // 领取者
            this.checkReport((myRole)=>{  //校验当前人是否为任务领取者
                change();
            })
        }


    };
    //关闭弹窗
    close=()=>{
        this.setState({visible:false})
    };
    //编辑
    edit = (data) => {
        this.setState({addInterviewTasksKey: uuid(),visible:false}, () => {
            this.addInterview.show(data,'修改')
        })
    };
    //修改状态
    modify =(data,name)=>{
        let parms ={
            "version": data.version,
            "status": name
        };
        this.request({
            url: "/cm-sites-business/bd/busTask/update/" +data.id,
            method: "post",
            body:parms,
            contentType: 'json',
            callBack: (data) => {
                if (data) {
                    message.destroy();
                    this.getData(this.state.taskId, (res) => {
                        this.state.data = res;
                        this.setState({},()=>{
                            this.isShowBtn(this.state.tableList);
                            this.taskMessage.getPropsData()
                        });

                    });
                    message.success('修改状态成功');
                    this.props.callBack&&this.props.callBack()
                }
            }
        });
    };
    //领取任务
    receiveTask = (data)=>{
        this.checkReport((myRole)=>{
            this.request({
                url: "/cm-sites-business/bd/busTaskReporter/update/" +data[0].id,
                method: "post",
                body:{
                    "version": data[0].version,
                    "status": "进行中",
                    "takeDate": "currentTime",
                    "taskTitle":this.state.data.title,
                    "taskCreater":this.state.data.publisher.id
                },
                contentType: 'json',
                callBack: (data) => {
                    if (data) {
                        message.destroy();
                        this.getData(this.state.taskId, (res) => {
                            this.state.data = res;
                            this.setState({},()=>{
                                this.isShowBtn(this.state.tableList);
                                this.taskMessage.getPropsData()
                            });
                        });
                        message.success('领取成功');
                        this.props.callBack&&this.props.callBack();
                    }
                }
            });
        });

    };
    checkReport = (call)=>{

        this.getData(this.state.taskId, (res) => {
            this.state.data = res;
            this.setState({},()=>{
                let data  =res&&res.taskReporterObjs?res.taskReporterObjs:[];
                let myRole=data&&data.length?data.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id)):'';
                if(myRole&&myRole.length){
                    call&&call(myRole)
                }else{
                    message.warning('任务信息已修改！');
                    this.props.callBack&&this.props.callBack();
                    this.setState({visible: false})
                }
            });
        });
    };
    //去写稿
    addStory = () => {
        this.checkReport((myRole)=>{
            let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.cflc", "activitiTreeRoot-task");
            const targetWindow = window.openEditById({
                configName:"taskStoryEditor",
                id:"0",
                params: {
                    taskId: this.state.taskId,
                    activitiConfName,
                    subtasksId:myRole[0].id
                }
            });
        });


    };

    onChange = (data,{file, fileList},current) => {
            fileList = fileList.filter(item=>item.status  !== 'done' );
            if (file.status === "done") {
                fileList = fileList.map(item => {
                    // 取决于需要什么数据填入fileList
                    if (item.uid === file.uid) {
                        if (file.response && file.response.data) {
                            //分片上传是走的自己封装的接口 所以返回值只有data
                            //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                            file.response = {...file.response.data, ...file.response};
                        }
                        item.status='done';
                        item.uid = file.uid;
                        item.ext = file.response && file.response.suffix;
                        item.url = file.response && file.response.path;
                        item.name = file.response && file.response.name || file.name;
                        item.isChunk = true;
                        item.status = file.status;
                        item.md5 = file.response && file.response.md5;
                    }
                    return item;
                });
                if (file.response && file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    file.response = {...file.response.data, ...file.response};
                }
                let path;
                let ext = file.response && file.response.suffix;
                let fid ='';
                if (PIC_TYPE.indexOf(ext) > -1 && current === '2') {
                    path = file.response.smallPath;
                    fid = this.state.data.taskPicture
                } else if (VIDEO_TYPE.indexOf(ext) > -1) {
                    path = file.response.thumbnailsPlayPath ? file.response.thumbnailsPlayPath : file.response.thumbnailsPath;
                    fid = this.state.data.taskVideo
                }
                let url, method, parms;
                url = "/cm-sites-storage-management/zykUpload/uploadFile?";
                method = 'post';
                parms = {
                    icon: path,
                    fid:fid,
                    storageFile: file.response
                };
                // 保存到资源库
                this.request({
                    url: url,
                    method: method,
                    body: parms,
                    contentType: 'json',
                    callBack: (data) => {
                        if (data) {
                            file.id = data[0].id;
                            if (current === '2' && this.taskPicture1?.getAllData) {
                                this.taskPicture1.getAllData(fileList,file)
                            } else if(current === '3' && this.taskPicture2?.getAllData){
                                this.taskPicture2.getAllData(fileList,file)
                            }
                            let notFidFileList = fileList.find(file=>!file.id);
                            if(!notFidFileList || notFidFileList.length < 2){
                                if (current === '2') {
                                    this.taskPicture1.getRightList()
                                } else {
                                    this.taskPicture2.getRightList()
                                }
                            }
                        }
                    }
                });
                let param;
                if (current === '2') {
                    param = {
                        "businessData": {
                            "version": '-1',
                            "taskPictureList": [
                                file.response
                            ]
                        },
                        "updateConfig": {
                            "taskPictureList": "addToSet"
                        }
                    };
                } else if(current === '3') {
                    param = {
                        "businessData": {
                            "version": '-1',
                            "taskVideoList": [
                                file.response
                            ]
                        },
                        "updateConfig": {
                            "taskVideoList": "addToSet"
                        }
                    };
                }
                let currentId;
                if(this.props.current==='2'){
                    currentId =  this.state.data.taskPicture;

                }else{
                    currentId = this.state.data.taskVideo;
                }
                //  保存到任务里面
                this.saveInterList(param,currentId,fileList,(list)=>{
                    fileList=list
                })
            }
            if (current === '2' && this.taskPicture1?.getAllData) {
                this.taskPicture1.getAllData(fileList,file)
            } else if(current === '3' && this.taskPicture2?.getAllData){
                this.taskPicture2.getAllData(fileList,file)
            }
    };

    saveInterList(param,currentId,fileList,call){
        this.request({
            url: "/cm-sites-business/bd/busTask/updateByConfig/" + this.state.data.id,
            method: "post",
            body: param,
            contentType: 'json',
            callBack: (data) => {
                 message.destroy();
                 message.success('上传成功');

            }
        });
    }
    closeNoAuth(){
        message.destroy();
        message.warning('任务信息已修改！');
        this.props.callBack&&this.props.callBack();
        this.setState({visible: false})
    }
}
